import React from 'react';
import colors from 'pubweb-react-components/dist/styles/colors';
import Heading from 'pubweb-react-components/dist/components/Typography/Heading';
import Form from '../Form/Form';
import {
    SubpageBodyContainer,
    BodyCopyContainer
} from './SubpageBodyStyles';

import LandingHeader from '../LandingHeader/LandingHeader';

const relativePath = process.env.RELATIVE_PATH;

const SubpageBody = ({
    children,
    headerText,
    subHeaderText,
    category,
    formHeading,
    backgroundImages
}) => {

    var redirectOnSubmit = (state) => {
        var redirectRelativePath = headerText.toLowerCase();
        if (state.isLeadForm) {
            window.location.href = `${relativePath}${redirectRelativePath}/thank-you?zip=${state.values.zip}`;
        } else {
            window.location.href = `${relativePath}${redirectRelativePath}/thanks`;
        }
    }

    return (
        <SubpageBodyContainer
            backgroundImages={backgroundImages}>
            <div className="header-overlay">
                <div className="header-overlay-filter"></div>
            </div>
            <div className="subpage-column-left">
                <span className="subpage-header">
                    <Heading
                        headingSize="xxlarge"
                        headingTag="h1"
                        headingColor={colors.wsWhite}>
                        {headerText}
                    </Heading>
                </span>
                <div className="subpage-content">
                    <Heading
                        headingSize="xlarge"
                        headingTag="h2"
                        headingColor={colors.grayscaleCoolGray11}>
                        {subHeaderText}
                    </Heading>
                    <BodyCopyContainer>
                        {children}
                    </BodyCopyContainer>
                </div>
            </div>
            <div className="subpage-column-right">
                <Form formTypes={{ originWebApp: 'clayton-homes-website', originWebPageType: 'him-campaign-landing-page', originCampaign: 'him-2018', originWebFormCategory: category }}
                    options={{ formHeading: formHeading, redirect: redirectOnSubmit }} />
            </div>

        </SubpageBodyContainer>
    )
};

export default SubpageBody;



// WEBPACK FOOTER //
// ./src/components/SubpageBody/SubpageBody.js